namespace TabAurous.OMS {
    export interface FixedCodeRow {
        FixedId?: number;
        FixedCode?: string;
        FixedName?: string;
        FixedType?: string;
        MasterName?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace FixedCodeRow {
        export const idProperty = 'FixedId';
        export const nameProperty = 'FixedCode';
        export const localTextPrefix = 'OMS.FixedCode';
        export const lookupKey = 'OMS.FixedData';

        export function getLookup(): Q.Lookup<FixedCodeRow> {
            return Q.getLookup<FixedCodeRow>('OMS.FixedData');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            FixedId = "FixedId",
            FixedCode = "FixedCode",
            FixedName = "FixedName",
            FixedType = "FixedType",
            MasterName = "MasterName",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
